import { ActionType } from "../types";
import { Settings, SettingsAction } from "../types/settings";

export const settings = (
  state: Settings = null,
  action: SettingsAction
): Settings => {
  switch (action.type) {
    case ActionType.GET_SETTINGS_SUCCESS:
      return action.settings
        ? {
            ...action.settings,
          }
        : null;
    default:
      return state;
  }
};
